import { StyleSheet, Platform } from 'react-native';
import { getResponsiveValue } from './breakpoints';
import { colors, spacing, typography } from '../styles/theme';

export const venueListStyles = StyleSheet.create({
  venueListContainer: {
    flex: 1,
    width: '100%',
    maxWidth: 1400,
    alignSelf: 'center',
    paddingTop: 0,
  },
  searchWrapper: {
    width: '100%',
    maxWidth: 1400,
    marginHorizontal: 'auto',
    paddingHorizontal: 20,
  },
  searchContainer: {
    width: '100%',
    maxWidth: getResponsiveValue({
      mobile: '100%',
      tablet: 600,
      laptop: 800,
      desktop: 900
    }),
    minWidth: getResponsiveValue({
      mobile: '100%',
      tablet: '80%',
      laptop: '60%',
      desktop: '50%'
    }),
    marginTop: getResponsiveValue({
      mobile: 20,
      tablet: 20,
      laptop: 20,
      desktop: 20
    }),
    marginLeft: 'auto',
    marginRight: 'auto',
    position: 'relative',
    zIndex: 4,
    alignSelf: 'center',
    borderBottomWidth: 1,
    borderBottomColor: 'rgba(0, 0, 0, 0.5)',
  },
  searchInput: {
    fontFamily: 'VastagoGrotesk',
    backgroundColor: 'transparent',
    color: '#ffffff',
    width: '100%',
    fontSize: getResponsiveValue({
      mobile: 16,
      tablet: 14,
      laptop: 20,
      desktop: 22,
    }),
    height: getResponsiveValue({
      mobile: 50,
      tablet: 60,
      laptop: 50,
      desktop: 60,
    }),
    paddingHorizontal: getResponsiveValue({
      mobile: 20,
      tablet: 25,
      laptop: 30,
      desktop: 30,
    }),
    paddingRight: getResponsiveValue({
      mobile: 50,
      tablet: 60,
      laptop: 60,
      desktop: 70,
    }),
    ...(Platform.OS === 'web' && {
      outlineStyle: 'none',
      border: 'none',
    }),
  },
  venueGrid: {
    flex: 1,
    width: '100%',
    maxWidth: 1400,
    flexGrow: 1,
    alignSelf: 'center',
    marginTop: 5,
  },
  resultsContainer: {
    marginTop: getResponsiveValue({
      mobile: 10,
      tablet: 20,
      laptop: 30,
      desktop: 30
    }),
    display: 'grid',
    gridTemplateColumns: getResponsiveValue({
      mobile: 'repeat(1, 1fr)',
      tablet: 'repeat(2, 1fr)',
      laptop: 'repeat(3, 1fr)',
      desktop: 'repeat(3, 1fr)'
    }),
    gap: getResponsiveValue({
      mobile: 15,
      tablet: 15,
      laptop: 25,
      desktop: 30
    }),
    alignItems: 'center',
    justifyItems: getResponsiveValue({
      mobile: 'center',
      tablet: 'stretch',
      laptop: 'stretch',
      desktop: 'stretch'
    }),
    position: 'relative',
    paddingHorizontal: getResponsiveValue({
      mobile: 0,
      tablet: 20,
      laptop: 20,
      desktop: 20
    }),
    marginBottom: getResponsiveValue({
      mobile: 20,
      tablet: 30,
      laptop: 40,
      desktop: 40
    }),
  },
  venueCard: {
    backgroundColor: '#3D7FE6',
    borderRadius: 10,
    height: getResponsiveValue({
      mobile: 180,
      tablet: 240,
      laptop: 300,
      desktop: 300
    }),
    position: 'relative',
    overflow: 'hidden',
    width: getResponsiveValue({
      mobile: '90vw',
      tablet: '100%',
      laptop: '100%',
      desktop: '100%'
    }),
    marginLeft: getResponsiveValue({
      mobile: 'auto',
      tablet: 0,
      laptop: 0,
      desktop: 0
    }),
    marginRight: getResponsiveValue({
      mobile: 'auto',
      tablet: 0,
      laptop: 0,
      desktop: 0
    }),
    ...(Platform.OS === 'web' && {
      cursor: 'pointer',
      transition: 'transform 0.3s ease-in-out, box-shadow 0.3s ease-in-out',
      ':hover': {
        transform: 'scale(1.02)',
        boxShadow: '0 12px 20px rgba(0,0,0,0.3)',
      },
    }),
  },
  venueCardBackground: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    opacity: 0.5,
  },
  venueCardContent: {
    position: 'relative',
    zIndex: 1,
    height: '100%',
    width: '100%',
    padding: getResponsiveValue({
      mobile: 10,
      tablet: 15,
      laptop: 20,
      desktop: 25
    }),
    paddingBottom: getResponsiveValue({
      mobile: 14,
      tablet: 18,
      laptop: 24,
      desktop: 28
    }),
    backdropFilter: Platform.OS === 'web' ? 'blur(1px)' : undefined,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  venueCardName: {
    fontFamily: 'VastagoGrotesk',
    fontWeight: '700',
    fontSize: getResponsiveValue({
      mobile: 19,
      tablet: 18,
      laptop: 24,
      desktop: 26,
    }),
    color: colors.venueName,
    marginBottom: getResponsiveValue({
      mobile: 2,
      tablet: 5,
      laptop: 5,
      desktop: 5
    }),
    textAlign: 'center',
    textShadow: Platform.OS === 'web' ? '0px 2px 4px rgba(0, 0, 0, 0.5)' : undefined,
  },
  venueCardLocation: {
    fontSize: getResponsiveValue({ mobile: 14, tablet: 14, laptop: 16, desktop: 16 }),
    color: colors.textSecondary,
    marginBottom: spacing.xs,
    fontFamily: typography.fontFamily.medium,
    fontStyle: 'italic',
    textAlign: 'center',
    width: '100%',
  },
  venueCardDetails: {
    marginTop: getResponsiveValue({
      mobile: 10,
      tablet: 10,
      laptop: 10,
      desktop: 10
    }),
  },
  venueCardInfo: {
    fontFamily: 'VastagoGrotesk',
    fontWeight: '400',
    fontSize: getResponsiveValue({
      mobile: 14,
      tablet: 15,
      laptop: 18,
      desktop: 18,
    }),
    color: '#ffffff',
    marginBottom: getResponsiveValue({
      mobile: 5,
      tablet: 5,
      laptop: 5,
      desktop: 5
    }),
    textAlign: 'center',
    textShadow: Platform.OS === 'web' ? '0px 4px 4px rgba(0,0,0,0.25)' : undefined,
  },
  venueCardCapacity: {
    color: '#FFCB9C',
    fontSize: getResponsiveValue({ mobile: 14, tablet: 15, laptop: 18, desktop: 18 }),
  },
  venueCardStage: {
    color: 'rgba(255, 255, 255, 0.7)',
    fontFamily: 'VastagoGrotesk',
    fontWeight: '400',
    fontSize: getResponsiveValue({ mobile: 14, tablet: 15, laptop: 16, desktop: 16 }),
    fontStyle: 'italic',
  },
  venueCardAddress: {
    color: '#ffffff',
    fontSize: getResponsiveValue({
      mobile: 14,
      tablet: 14,
      laptop: 17,
      desktop: 17
    }),
    fontFamily: 'VastagoGrotesk',
    marginBottom: 5,
    opacity: 0.8,
  },
  scoreDebugContainer: {
    marginTop: 15,
    padding: 10,
    backgroundColor: 'rgba(0, 0, 0, 0.3)',
    borderRadius: 5,
    alignItems: 'center',
  },
  scoreText: {
    fontFamily: 'VastagoGrotesk',
    fontWeight: '700',
    fontSize: 16,
    textShadow: Platform.OS === 'web' ? '0px 2px 2px rgba(0,0,0,0.25)' : undefined,
  },
  matchTypesText: {
    fontFamily: 'VastagoGrotesk',
    fontWeight: '400',
    fontSize: 12,
    color: 'rgba(255, 255, 255, 0.7)',
    textAlign: 'center',
    marginTop: 5,
    fontStyle: 'italic',
  },
  actionButtonsContainer: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    justifyContent: 'center',
    gap: getResponsiveValue({
      mobile: 10,
      tablet: 15,
      laptop: 20,
      desktop: 20
    }),
    marginTop: getResponsiveValue({
      mobile: 20,
      tablet: 20,
      laptop: 20,
      desktop: 40
    }),
    width: '100%',
    height: 'auto',
  },
  actionButton: {
    backgroundColor: '#0bb5df',
    borderRadius: 20,
    borderTopRightRadius: 0,
    borderBottomLeftRadius: 0,
    padding: getResponsiveValue({
      mobile: 10,
      tablet: 12,
      laptop: 15,
      desktop: 15
    }),
    minWidth: getResponsiveValue({
      mobile: '100%',
      tablet: 200,
      laptop: 200,
      desktop: 250
    }),
    alignItems: 'center',
    boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.25)',
    ...(Platform.OS === 'web' && {
      cursor: 'pointer',
    }),
  },
  actionButtonText: {
    color: 'white',
    fontFamily: 'system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',
    fontWeight: '700',
    fontSize: getResponsiveValue({
      mobile: 14,
      tablet: 16,
      laptop: 16,
      desktop: 18
    }),
    textTransform: 'uppercase',
  },
  noResultsText: {
    fontFamily: 'VastagoGrotesk',
    fontWeight: '500',
    fontSize: getResponsiveValue({
      mobile: 16,
      tablet: 14,
      laptop: 20,
      desktop: 20
    }),
    color: 'white',
    textAlign: 'center',
    marginTop: 20,
  },
  filterContainer: {
    position: 'relative',
    minWidth: getResponsiveValue({
      mobile: '100%',
      tablet: '45%',
      laptop: '30%',
      desktop: '20%'
    }),
    maxWidth: getResponsiveValue({
      mobile: '100%',
      tablet: '45%',
      laptop: '30%',
      desktop: '20%'
    }),
    zIndex: getResponsiveValue({
      mobile: 9990,
      tablet: 9000,
      laptop: 900,
      desktop: 900
    }),
    marginBottom: getResponsiveValue({
      mobile: 5,
      tablet: 10,
      laptop: 10,
      desktop: 10
    }),
    ...(Platform.OS === 'web' && {
      isolation: 'isolate',
    }),
  },
  filterButtonsRow: {
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    gap: 12,
    marginBottom: 15,
    marginTop: 5,
    paddingHorizontal: getResponsiveValue({
      mobile: 5,
      tablet: 10,
      laptop: 15,
      desktop: 15
    }),
  },
  clearFiltersButton: {
    backgroundColor: 'rgba(255, 255, 255, 0.1)',
    paddingVertical: 12,
    paddingHorizontal: 16,
    borderRadius: 25,
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    ...(Platform.OS === 'web' && {
      cursor: 'pointer',
      transition: 'all 0.2s ease',
      ':hover': {
        backgroundColor: 'rgba(255, 255, 255, 0.2)',
        transform: 'scale(1.05)',
      },
      ':active': {
        transform: 'scale(0.98)',
      }
    }),
  },
  clearFiltersText: {
    color: '#000000',
    fontFamily: 'VastagoGrotesk',
    fontSize: 14,
    fontWeight: '500',
  },
  filterMainButton: {
    backgroundColor: colors.backgroundSquares,
    borderRadius: 8,
    padding: 12,
    minWidth: getResponsiveValue({
      mobile: '30%',
      tablet: 150,
      laptop: 180,
      desktop: 200
    }),
    alignItems: 'center',
    justifyContent: 'center',
    borderWidth: 1,
    borderColor: 'rgba(255, 255, 255, 0.2)',
    ...(Platform.OS === 'web' && {
      cursor: 'pointer',
      transition: 'all 0.2s ease',
      ':hover': {
        backgroundColor: 'rgba(155, 77, 255, 0.2)',
        borderColor: '#9B4DFF',
      }
    }),
  },
  filterMainButtonActive: {
    backgroundColor: '#9B4DFF',
    borderColor: '#9B4DFF',
  },
  filterMainButtonText: {
    color: 'white',
    fontFamily: 'VastagoGrotesk',
    fontWeight: '500',
    fontSize: 14,
    textAlign: 'center',
  },
  filterDropdown: {
    marginTop: 10,
    width: '100%',
    backgroundColor: 'rgba(0, 0, 0, 0.3)',
    borderRadius: 8,
    padding: 10,
    ...(Platform.OS === 'web' && {
      transition: 'opacity 0.2s ease-out, transform 0.2s ease-out',
    }),
  },
  filterButton: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    backgroundColor: colors.backgroundSquares,
    borderRadius: 8,
    padding: getResponsiveValue({
      mobile: 8,
      tablet: 12,
      laptop: 12,
      desktop: 12
    }),
    paddingHorizontal: getResponsiveValue({
      mobile: 10,
      tablet: 15,
      laptop: 15,
      desktop: 15
    }),
    gap: 10,
    backdropFilter: Platform.OS === 'web' ? 'blur(10px)' : undefined,
    borderWidth: 1,
    borderColor: 'transparent',
    minWidth: getResponsiveValue({
      mobile: 130,
      tablet: 150,
      laptop: 150,
      desktop: 150
    }),
    maxWidth: getResponsiveValue({
      mobile: '48%',
      tablet: 'auto',
      laptop: 'auto',
      desktop: 'auto'
    }),
    ...(Platform.OS === 'web' && {
      cursor: 'pointer',
      transition: 'all 0.2s ease',
      '&:hover': {
        backgroundColor: 'rgba(255, 255, 255, 0.15)',
      },
    }),
  },
  filterButtonText: {
    color: 'white',
    fontSize: getResponsiveValue({
      mobile: 13,
      tablet: 14,
      laptop: 14,
      desktop: 14
    }),
    fontFamily: 'VastagoGrotesk',
    fontWeight: '500',
    flex: 1,
    textAlign: 'left',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  filterButtonActive: {
    backgroundColor: '#9B4DFF',
    borderColor: '#9B4DFF',
  },
  filterOption: {
    paddingVertical: getResponsiveValue({
      mobile: 20,
      tablet: 12,
      laptop: 10,
      desktop: 10
    }),
    paddingHorizontal: getResponsiveValue({
      mobile: 15,
      tablet: 15,
      laptop: 15,
      desktop: 15
    }),
    marginVertical: getResponsiveValue({
      mobile: 5,
      tablet: 2,
      laptop: 2,
      desktop: 2
    }),
    borderWidth: 1,
    borderColor: colors.purpleReplacement,
    borderRadius: 8,
    marginRight: 10,
    backgroundColor: getResponsiveValue({
      mobile: 'rgba(66, 66, 66, 0.75)',
      tablet: 'transparent',
      laptop: 'transparent',
      desktop: 'transparent'
    }),
  },
  filterOptionSelected: {
    backgroundColor: colors.purpleReplacement,
    borderColor: colors.purpleReplacement,
  },
  filterOptionText: {
    color: 'white',
    fontSize: getResponsiveValue({
      mobile: 16,
      tablet: 14,
      laptop: 14,
      desktop: 14
    }),
    fontFamily: 'VastagoGrotesk',
    textAlign: 'center',
  },
  filterOptionTextSelected: {
    fontWeight: '500',
  },

  closeFilterButton: {
    alignSelf: 'center',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    paddingVertical: 8,
    paddingHorizontal: 16,
    marginBottom: 10,
    borderRadius: 20,
    backgroundColor: 'rgba(0, 0, 0, 0.3)',
    boxShadow: '0 2px 4px rgba(0,0,0,0.2)',
    ...(Platform.OS === 'web' && {
      cursor: 'pointer',
      transition: 'background-color 0.2s ease',
      ':hover': {
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
      },
    }),
  },
  closeFilterButtonText: {
    color: 'white',
    fontFamily: 'VastagoGrotesk',
    fontSize: 14,
    fontWeight: '500',
    display: 'flex',
    alignItems: 'center',
    gap: 5,
  },
  mobileFilterToggleButton: {
    backgroundColor: colors.purpleReplacement,
    paddingVertical: 12,
    paddingHorizontal: 20,
    borderRadius: 25,
    alignSelf: 'center',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    marginBottom: 15,
    marginTop: 5,
    width: 'auto',
    minWidth: 150,
    display: 'none',
    boxShadow: '0 3px 10px rgba(0,0,0,0.35)',
    zIndex: 100,
    position: 'sticky',
    top: getResponsiveValue({
      mobile: 85,
      tablet: 85,
      laptop: 85,
      desktop: 85
    }),
    ...(Platform.OS === 'web' && {
      '@media (min-width: 769px)': {
        display: 'none',
      },
      transition: 'transform 0.2s ease, background-color 0.2s ease',
      ':hover': {
        transform: 'scale(1.05)',
        backgroundColor: '#ab5aff',
      },
      ':active': {
        transform: 'scale(0.98)',
      }
    }),
  },
  mobileFilterToggleButtonActive: {
    backgroundColor: '#ab5aff',
    boxShadow: '0 3px 12px rgba(155, 77, 255, 0.5)',
  },
  mobileFilterToggleText: {
    color: 'white',
    fontFamily: 'VastagoGrotesk',
    fontSize: 16,
    fontWeight: '600',
    display: 'flex',
    alignItems: 'center',
    gap: 5,
  },
  filterOptions: {
    marginTop: 5,
    backgroundColor: 'rgba(0, 0, 0, 0.95)',
    borderRadius: 8,
    padding: getResponsiveValue({
      mobile: 0,
      tablet: 8,
      laptop: 8,
      desktop: 8
    }),
    minWidth: getResponsiveValue({
      mobile: '100%',
      tablet: '100%',
      laptop: '100%',
      desktop: '100%'
    }),
    maxHeight: getResponsiveValue({
      mobile: '60vh',
      tablet: 300,
      laptop: 300,
      desktop: 300
    }),
    overflowY: 'auto',
    ...(Platform.OS === 'web' ? { boxShadow: '0 10px 25px rgba(0,0,0,0.7)' } : {
      shadowColor: '#000',
      shadowOffset: { width: 0, height: 10 },
      shadowOpacity: 0.5,
      shadowRadius: 15,
      elevation: 20,
    }),
    zIndex: getResponsiveValue({
      mobile: 100000,
      tablet: 9999,
      laptop: 9999,
      desktop: 9999
    }),
    backdropFilter: Platform.OS === 'web' ? 'blur(10px)' : undefined,
    boxShadow: '0 10px 25px rgba(0,0,0,0.7)',
    ...(Platform.OS === 'web' && {
      position: getResponsiveValue({
        mobile: 'relative',
        tablet: 'absolute',
        laptop: 'absolute',
        desktop: 'absolute'
      }),
      top: getResponsiveValue({
        mobile: 0,
        tablet: '100%',
        laptop: '100%',
        desktop: '100%'
      }),
      left: getResponsiveValue({
        mobile: 0,
        tablet: '50%',
        laptop: '50%',
        desktop: '50%'
      }),
      transform: getResponsiveValue({
        mobile: 'none',
        tablet: 'translateX(-50%)',
        laptop: 'translateX(-50%)',
        desktop: 'translateX(-50%)'
      }),
      width: getResponsiveValue({
        mobile: '100%',
        tablet: 'auto',
        laptop: 'auto',
        desktop: 'auto'
      }),
      minWidth: getResponsiveValue({
        mobile: '100%',
        tablet: 200,
        laptop: 200,
        desktop: 200
      }),
      marginLeft: getResponsiveValue({
        mobile: 'auto',
        tablet: 0,
        laptop: 0,
        desktop: 0
      }),
      marginRight: getResponsiveValue({
        mobile: 'auto',
        tablet: 0,
        laptop: 0,
        desktop: 0
      }),
    }),
  },
  featureFilterOptions: {
    width: 'auto',
    minWidth: getResponsiveValue({
      mobile: '98%',
      tablet: 250,
      laptop: 250,
      desktop: 250
    }),
    padding: 5,
    paddingBottom: 8,
    maxHeight: getResponsiveValue({
      mobile: 300,
      tablet: 300,
      laptop: 300,
      desktop: 300
    }),
    overflowY: 'auto',
  },
  featureCheckboxesGrid: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    gap: getResponsiveValue({
      mobile: 10,
      tablet: 0,
      laptop: 0,
      desktop: 0
    }),
    paddingVertical: getResponsiveValue({
      mobile: 10,
      tablet: 4,
      laptop: 4,
      desktop: 4
    }),
    paddingHorizontal: getResponsiveValue({
      mobile: 2,
      tablet: 2,
      laptop: 2,
      desktop: 2
    }),
  },
  featureCheckbox: {
    flexDirection: 'row',
    alignItems: 'center',
    padding: getResponsiveValue({
      mobile: 10,
      tablet: 6,
      laptop: 6,
      desktop: 6
    }),
    paddingVertical: getResponsiveValue({
      mobile: 10,
      tablet: 6,
      laptop: 6,
      desktop: 6
    }),
    borderRadius: 6,
    width: '100%',
    marginBottom: 0,
    marginVertical: getResponsiveValue({
      mobile: 2,
      tablet: 1,
      laptop: 1,
      desktop: 1
    }),
    ...(Platform.OS === 'web' && {
      cursor: 'pointer',
      transition: 'all 0.2s ease',
      '&:hover': {
        backgroundColor: 'rgba(255, 255, 255, 0.1)',
      },
    }),
  },
  checkboxContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    width: '100%',
  },
  checkbox: {
    width: getResponsiveValue({
      mobile: 18,
      tablet: 14,
      laptop: 14,
      desktop: 14
    }),
    height: getResponsiveValue({
      mobile: 18,
      tablet: 14,
      laptop: 14,
      desktop: 14
    }),
    borderWidth: 1,
    borderColor: 'rgba(155, 77, 255, 0.7)',
    borderRadius: 2,
    marginRight: 8,
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: 'rgba(0, 0, 0, 0.2)',
    boxShadow: '0px 1px 2px rgba(0, 0, 0, 0.3)',
    minWidth: getResponsiveValue({
      mobile: 18,
      tablet: 14,
      laptop: 14,
      desktop: 14
    }),
    flexShrink: 0,
  },
  checkboxChecked: {
    backgroundColor: '#9B4DFF',
    borderColor: '#9B4DFF',
  },
  checkmark: {
    color: 'white',
    fontSize: getResponsiveValue({
      mobile: 10,
      tablet: 10,
      laptop: 10,
      desktop: 10
    }),
    fontWeight: 'bold',
    lineHeight: getResponsiveValue({
      mobile: 16,
      tablet: 14,
      laptop: 14,
      desktop: 14
    }),
    textAlign: 'center',
  },
  checkboxLabel: {
    color: 'white',
    fontFamily: 'VastagoGrotesk',
    fontSize: getResponsiveValue({
      mobile: 14,
      tablet: 12,
      laptop: 12,
      desktop: 12
    }),
  },
  featureBadgesContainer: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    justifyContent: 'center',
    gap: getResponsiveValue({
      mobile: 3,
      tablet: 5,
      laptop: 6,
      desktop: 8
    }),
    marginTop: getResponsiveValue({
      mobile: 3,
      tablet: 5,
      laptop: 8,
      desktop: 10
    }),
    maxWidth: '100%',
  },
  featureBadge: {
    backgroundColor: 'rgba(129, 90, 179, 0.7)',
    paddingVertical: getResponsiveValue({
      mobile: 2,
      tablet: 3,
      laptop: 4,
      desktop: 5
    }),
    paddingHorizontal: getResponsiveValue({
      mobile: 5,
      tablet: 8,
      laptop: 10,
      desktop: 12
    }),
    borderRadius: 4,
    borderWidth: 1,
    borderColor: 'rgba(129, 90, 179, 0.9)',
  },
  featureBadgeText: {
    color: 'white',
    fontSize: getResponsiveValue({
      mobile: 11,
      tablet: 12,
      laptop: 13,
      desktop: 14
    }),
    fontFamily: 'VastagoGrotesk',
    fontWeight: '500',
  },
  filterSubmitButton: {
    backgroundColor: colors.purpleReplacement,
    borderColor: colors.purpleReplacement,
    padding: 15,
    borderRadius: 8,
    alignItems: 'center',
    justifyContent: 'center',
    marginTop: 15,
    cursor: 'pointer',
  },
  featureFilterButton: {
    backgroundColor: colors.purpleReplacement,
    borderWidth: 0,
    paddingVertical: 10,
    paddingHorizontal: 15,
    borderRadius: 8,
    marginTop: 10,
    alignItems: 'center',
    justifyContent: 'space-between',
    flexDirection: 'row',
  },
  moreFiltersButton: {
    backgroundColor: colors.purpleReplacement,
    borderColor: colors.purpleReplacement,
  },
  // Desktop filter styles
  desktopFilterContainer: {
    marginBottom: 0,
    flexShrink: 0,
  },
  desktopFeatureContainer: {
    marginBottom: 10,
    flex: 2,
  },
  desktopFilterTitle: {
    color: '#4e7de0',
    fontSize: 15,
    fontWeight: '600',
    marginBottom: 6,
    fontFamily: 'Playpen Sans',
    textDecorationLine: 'underline',
  },
  desktopOptionsGrid: {
    display: Platform.OS === 'web' ? 'grid' : 'flex',
    ...(Platform.OS === 'web' && {
      gridTemplateRows: 'repeat(6, auto)',
      gridAutoFlow: 'column',
      gridAutoColumns: 'minmax(150px, 1fr)',
      gap: 4,
    }),
    ...(Platform.OS !== 'web' && {
      flexDirection: 'column',
      flexWrap: 'wrap',
      gap: 4,
      maxHeight: 200,
    }),
  },
  desktopFeatureGrid: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    gap: 5,
  },
  desktopOption: {
    flexDirection: 'row',
    alignItems: 'flex-start',
    gap: 6,
    padding: 5,
    borderRadius: 6,
    backgroundColor: 'transparent',
    transition: 'all 0.2s ease',
    minWidth: 0,
    ...(Platform.OS === 'web' && {
      width: '100%',
      maxWidth: '100%',
      overflow: 'hidden',
      boxSizing: 'border-box',
    }),
  },
  desktopOptionTextSelected: {
    color: '#4e7de0',
    fontStyle: 'italic',
    letterSpacing: 1.3,
  },
  desktopOptionSelected: {
    backgroundColor: 'transparent',
  },
  desktopOptionDisabled: {
    opacity: 0.4,
    cursor: 'not-allowed',
  },
  desktopFeatureCheckbox: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 8,
    padding: 8,
    borderRadius: 6,
    backgroundColor: 'transparent',
    transition: 'all 0.2s ease',
    width: 'calc(50% - 6px)',
  },
  desktopOptionText: {
    color: '#000000',
    fontSize: 14,
    fontFamily: 'VastagoGrotesk',
    letterSpacing: 0.3,
  },
  desktopCheckboxLabel: {
    color: '#000000',
    fontSize: 14,
    fontFamily: 'Roboto',
    letterSpacing: 0.3,
    ...(Platform.OS === 'web' && {
      wordBreak: 'break-word',
      overflowWrap: 'break-word',
      minWidth: 0,
    }),
  },
  desktopCheckboxLabelWrap: {
    flex: 1,
    minWidth: 0,
    overflow: 'hidden',
  },
  checkbox: {
    width: 18,
    height: 18,
    borderRadius: 4,
    borderWidth: 2,
    borderColor: '#4e7de0',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: 'transparent',
  },
  checkboxChecked: {
    backgroundColor: '#4e7de0',
  },
  checkboxDisabled: {
    opacity: 0.4,
  },
  checkboxImage: {
    height: 18,
    width: 36,
  },
  checkmark: {
    color: 'white',
    fontSize: 12,
    fontWeight: 'bold',
  },
  filtersContainer: {
    width: '100%',
    backgroundColor: 'transparent',
    borderRadius: 12,
    padding: getResponsiveValue({
      mobile: 0,
      tablet: 12,
      laptop: 12,
      desktop: 12
    }),
    marginBottom: getResponsiveValue({
      mobile: 8,
      tablet: 12,
      laptop: 12,
      desktop: 12
    }),
    transition: Platform.OS === 'web' ? 'max-height 0.2s ease-in-out, opacity 0.2s ease-in-out' : undefined,
  },
  filtersRow: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    alignItems: 'flex-start',
    gap: getResponsiveValue({
      mobile: 8,
      tablet: 8,
      laptop: 8,
      desktop: 8
    }),
    marginBottom: getResponsiveValue({
      mobile: 6,
      tablet: 10,
      laptop: 10,
      desktop: 10
    }),
    width: '100%',
    paddingHorizontal: getResponsiveValue({
      mobile: 10,
      tablet: 0,
      laptop: 0,
      desktop: 0
    }),
  },
  // Mobile filter styles
  mobileFiltersContainer: {
    width: '100%',
    marginBottom: 10,
    display: 'flex',
    flexDirection: 'column',
  },
  mobileFilterContainer: {
    marginBottom: getResponsiveValue({
      mobile: 15,
      tablet: 12,
      laptop: 12,
      desktop: 12
    }),
    width: '100%',
    position: 'relative',
    zIndex: 100,
  },
  mobileFilterButton: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: 12,
    paddingVertical: 15,
    backgroundColor: 'rgba(0, 0, 0, 0.2)',
    borderRadius: 8,
  },
  mobileFilterTitle: {
    color: 'white',
    fontSize: 16,
    fontFamily: 'VastagoGrotesk',
    fontWeight: '500',
  },
  mobileDropdown: {
    marginTop: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.3)',
    borderRadius: 8,
    paddingHorizontal: getResponsiveValue({
      mobile: 6,
      tablet: 8,
      laptop: 8,
      desktop: 8
    }),
    paddingVertical: getResponsiveValue({
      mobile: 6,
      tablet: 8,
      laptop: 8,
      desktop: 8
    }),
    maxHeight: getResponsiveValue({
      mobile: 250,
      tablet: 300,
      laptop: 300,
      desktop: 300
    }),
    overflow: Platform.OS === 'web' ? 'auto' : 'scroll',
    width: '100%',
    zIndex: 1000,
  },
  mobileOption: {
    flexDirection: 'row',
    alignItems: 'center',
    paddingHorizontal: getResponsiveValue({
      mobile: 8,
      tablet: 10,
      laptop: 10,
      desktop: 10
    }),
    paddingVertical: getResponsiveValue({
      mobile: 8,
      tablet: 12,
      laptop: 12,
      desktop: 12
    }),
    minHeight: getResponsiveValue({
      mobile: 36,
      tablet: 44,
      laptop: 44,
      desktop: 44
    }),
    width: '100%',
    borderBottomWidth: 1,
    borderBottomColor: 'rgba(255, 255, 255, 0.05)',
    marginBottom: 2,
  },
  mobileOptionDisabled: {
    opacity: 0.5,
  },
  mobileCheckbox: {
    width: getResponsiveValue({
      mobile: 18,
      tablet: 20,
      laptop: 20,
      desktop: 20
    }),
    height: getResponsiveValue({
      mobile: 18,
      tablet: 20,
      laptop: 20,
      desktop: 20
    }),
    borderRadius: 4,
    borderWidth: 2,
    borderColor: '#4e7de0',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: 'transparent',
    marginTop: 2,
    flexShrink: 0,
  },
  mobileCheckboxDisabled: {
    opacity: 0.4,
  },
  mobileCheckboxChecked: {
    backgroundColor: '#4e7de0',
  },
  mobileOptionText: {
    color: '#000000',
    fontSize: getResponsiveValue({
      mobile: 13,
      tablet: 15,
      laptop: 15,
      desktop: 15
    }),
    fontFamily: 'VastagoGrotesk',
    fontWeight: '400',
    letterSpacing: 0.3,
    flexWrap: 'wrap',
    flex: 1,
    marginLeft: getResponsiveValue({
      mobile: 8,
      tablet: 10,
      laptop: 10,
      desktop: 10
    }),
    lineHeight: getResponsiveValue({
      mobile: 16,
      tablet: 20,
      laptop: 20,
      desktop: 20
    }),
  },
  mobileOptionTextSelected: {
    color: '#4e7de0',
    fontStyle: 'italic',
    letterSpacing: 0.3,
  },
  filterChipText: {
    fontFamily: 'VastagoGrotesk',
    fontSize: getResponsiveValue({
      mobile: 11,
      tablet: 11,
      laptop: 13,
      desktop: 13
    }),
    color: '#333',
    paddingVertical: 2,
    paddingHorizontal: 1,
    letterSpacing: 0.2,
  },
  filterChipTextActive: {
    color: '#4e7de0',
    fontStyle: 'italic',
    textDecorationLine: 'underline',
  },
  chipGrid4: {
    width: '100%',
    minWidth: 800,
    ...(Platform.OS === 'web' ? {
      display: 'grid',
      gridTemplateRows: getResponsiveValue({
        mobile: 'repeat(12, auto)',
        tablet: 'repeat(8, auto)',
        laptop: 'repeat(4, auto)',
        desktop: 'repeat(4, auto)'
      }),
      gridAutoFlow: 'column',
      gridAutoColumns: getResponsiveValue({
        mobile: 'minmax(105px, 1fr)',
        tablet: 'minmax(105px, 1fr)',
        laptop: 'minmax(105px, 1fr)',
        desktop: 'minmax(110px, 1fr)'
      }),
      gap: 2,
    } : {
      flexDirection: 'row',
      flexWrap: 'wrap',
    }),
  },
  chipCell4: {
    ...(Platform.OS !== 'web' && { 
      width: getResponsiveValue({
        mobile: '20%',
        tablet: '20%',
        laptop: '25%',
        desktop: '25%'
      }) 
    }),
    paddingVertical: 2,
    paddingHorizontal: 2,
  },
  filterToggleButton: {
    backgroundColor: colors.purpleReplacement,
    paddingVertical: 12,
    paddingHorizontal: 20,
    borderRadius: 25,
    alignSelf: 'center',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    marginBottom: 15,
    marginTop: 5,
    width: 'auto',
    minWidth: 150,
    boxShadow: '0 3px 10px rgba(0,0,0,0.35)',
    zIndex: 100,
    ...(Platform.OS === 'web' && {
      cursor: 'pointer',
      transition: 'transform 0.2s ease, background-color 0.2s ease',
      ':hover': {
        transform: 'scale(1.05)',
        backgroundColor: '#ab5aff',
      },
      ':active': {
        transform: 'scale(0.98)',
      }
    }),
  },
  filterToggleButtonShow: {
    backgroundColor: colors.purpleReplacement,
  },
  filterToggleButtonActive: {
    backgroundColor: '#ab5aff',
    boxShadow: '0 3px 12px rgba(155, 77, 255, 0.5)',
  },
  filterToggleText: {
    color: 'white',
    fontFamily: 'VastagoGrotesk',
    fontSize: 16,
    fontWeight: '600',
  },
  locationIconContainer: {
    position: 'absolute',
    right: getResponsiveValue({
      mobile: 20,
      tablet: 25,
      laptop: 25,
      desktop: 30,
    }),
    top: '50%',
    transform: Platform.OS === 'web' ? 'translateY(-50%)' : undefined,
    height: getResponsiveValue({
      mobile: 30,
      tablet: 40,
      laptop: 40,
      desktop: 40,
    }),
    width: getResponsiveValue({
      mobile: 30,
      tablet: 40,
      laptop: 40,
      desktop: 40,
    }),
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 10,
    ...(Platform.OS === 'web' && {
      cursor: 'pointer',
      transition: 'all 0.2s ease',
      ':hover': {
        transform: 'translateY(-50%) scale(1.1)',
      },
    }),
  },
  svgIcon: {
    width: 24,
    height: 24,
    justifyContent: 'center',
    alignItems: 'center',
    position: 'relative',
  },
  locationDot: {
    position: 'absolute',
    width: 6,
    height: 6,
    borderRadius: 3,
    backgroundColor: '#000000',
    zIndex: 2,
    top: '50%',
    left: '50%',
    transform: Platform.OS === 'web' ? 'translate(-50%, -50%)' : undefined,
  },
  locationRing: {
    position: 'absolute',
    width: 18,
    height: 18,
    borderRadius: 10,
    borderWidth: 1.5,
    borderColor: '#000000',
    backgroundColor: 'transparent',
    top: '50%',
    left: '50%',
    transform: Platform.OS === 'web' ? 'translate(-50%, -50%)' : undefined,
  },
  // Context Active Button styles
  contextActiveButton: {
    flexDirection: 'row',
    alignItems: 'center',
    backgroundColor: '#4CAF50', // Green color
    paddingHorizontal: 12,
    paddingVertical: 8,
    marginBottom: 15,
    marginTop: 5,
    borderRadius: 6,
    marginLeft: 10,
    ...(Platform.OS === 'web' ? { boxShadow: '0 2px 6px rgba(0,0,0,0.15)' } : {
      shadowColor: '#000',
      shadowOffset: { width: 0, height: 2 },
      shadowOpacity: 0.1,
      shadowRadius: 3,
      elevation: 2,
    }),
  },
  
  contextActiveText: {
    color: '#fff',
    fontWeight: '500',
    fontSize: 14,
  },

  // Venue count display styles
  venueCountContainer: {
    paddingHorizontal: 20,
    paddingVertical: 8,
    alignItems: 'flex-end',
    marginTop: 10,
  },

  venueListHeaderSection: {
    marginTop: 20,
    flexDirection: 'row',
    justifyContent: 'space-between', 
    alignItems: 'center',
    paddingHorizontal: 20,
  },

  postButton: {
    fontSize: getResponsiveValue({
      mobile: 16,
      tablet: 18,
      laptop: 20,
      desktop: 24
    }),
    fontFamily: 'Playpen Sans',
    color: '#fbcd9d',
  },

  postButtonContainer: {
    alignItems: 'center',
    justifyContent: 'center',
  },

  venueCountText: {
    color: '#000000',
    fontFamily: 'VastagoGrotesk',
    fontSize: getResponsiveValue({
      mobile: 14,
      tablet: 15,
      laptop: 16,
      desktop: 16
    }),
    fontWeight: '500',
    opacity: 0.9,
    textAlign: 'center',
  },
  capacityNumberText: {
    fontFamily: 'Roboto',
    fontWeight: '400',
  },
  capacityInputsContainer: {
    width: '100%',
  },
  capacityInputRow: {
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: 10,
    gap: 8,
  },
  capacityInput: {
    borderWidth: 2,
    borderColor: '#4e7de0',
    borderRadius: 4,
    padding: 8,
    fontSize: 14,
    fontFamily: 'Roboto',
    textAlign: 'center',
    width: getResponsiveValue({
      mobile: 90,
      tablet: 100,
      laptop: 120,
      desktop: 120
    }),
    color: '#000000',
    backgroundColor: 'transparent',
    ...(Platform.OS === 'web' && {
      outlineStyle: 'none',
    }),
  },
  capacityToText: {
    color: '#000000',
    fontSize: 14,
    fontFamily: 'VastagoGrotesk',
    letterSpacing: 0.3,
  },

  // Mobile Tabbed Filter Styles
  mobileFilterTabs: {
    backgroundColor: 'transparent',
    borderRadius: 12,
    margin: getResponsiveValue({
      mobile: 10,
      tablet: 10,
      laptop: 10,
      desktop: 10
    }),
    marginBottom: 20,
    backdropFilter: Platform.OS === 'web' ? 'blur(10px)' : undefined,
  },

  mobileTabHeaders: {
    flexDirection: 'row',
    backgroundColor: 'transparent',
    width: '100%',
  },

  mobileTabHeader: {
    flex: 1,
    paddingVertical: getResponsiveValue({
      mobile: 12,
      tablet: 14,
      laptop: 14,
      desktop: 14
    }),
    paddingHorizontal: getResponsiveValue({
      mobile: 8,
      tablet: 12,
      laptop: 12,
      desktop: 12
    }),
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: 'transparent',
    borderBottomWidth: 2,
    borderBottomColor: 'transparent',
    ...(Platform.OS === 'web' && {
      cursor: 'pointer',
      transition: 'all 0.2s ease',
    }),
  },

  mobileTabHeaderActive: {
    // backgroundColor: 'rgba(155, 77, 255, 0.3)',
    borderBottomColor: '#9B4DFF',
  },

  mobileTabHeaderText: {
    color: '#4e7de0',
    fontSize: getResponsiveValue({
      mobile: 14,
      tablet: 15,
      laptop: 15,
      desktop: 15
    }),
    fontFamily: 'Playpen Sans',
    fontWeight: '500',
    textAlign: 'center',
    textDecorationLine: 'underline',
  },

  mobileTabHeaderTextActive: {
    color: '#4e7de0',
    fontWeight: '600',
    textDecorationLine: 'underline',
  },

  // Active Filters Display
  mobileActiveFilters: {
    padding: getResponsiveValue({
      mobile: 12,
      tablet: 14,
      laptop: 14,
      desktop: 14
    }),
    backgroundColor: 'transparent',
    borderBottomWidth: 1,
    borderBottomColor: 'transparent',
  },

  activeFiltersTitle: {
    color: '#4e7de0',
    fontSize: getResponsiveValue({
      mobile: 12,
      tablet: 13,
      laptop: 13,
      desktop: 13
    }),
    fontFamily: 'Playpen Sans',
    fontWeight: '600',
    marginBottom: 8,
  },

  activeFiltersContainer: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    gap: getResponsiveValue({
      mobile: 6,
      tablet: 8,
      laptop: 8,
      desktop: 8
    }),
  },

  activeFilterChip: {
    flexDirection: 'row',
    alignItems: 'center',
    backgroundColor: '#4e7de0',
    borderRadius: 16,
    paddingVertical: getResponsiveValue({
      mobile: 4,
      tablet: 6,
      laptop: 6,
      desktop: 6
    }),
    paddingHorizontal: getResponsiveValue({
      mobile: 8,
      tablet: 10,
      laptop: 10,
      desktop: 10
    }),
    maxWidth: '48%',
    ...(Platform.OS === 'web' && {
      cursor: 'pointer',
      transition: 'all 0.2s ease',
      ':hover': {
        backgroundColor: '#6a9be8',
      },
    }),
  },

  activeFilterText: {
    color: 'white',
    fontSize: getResponsiveValue({
      mobile: 11,
      tablet: 12,
      laptop: 12,
      desktop: 12
    }),
    fontFamily: 'VastagoGrotesk',
    fontWeight: '500',
    fontStyle: 'italic',
    letterSpacing: 0.3,
    marginRight: 4,
    flex: 1,
  },

  activeFilterRemove: {
    color: 'white',
    fontSize: getResponsiveValue({
      mobile: 16,
      tablet: 18,
      laptop: 18,
      desktop: 18
    }),
    fontWeight: 'bold',
    marginLeft: 4,
    minWidth: 16,
    textAlign: 'center',
  },

  mobileTabContent: {
    paddingHorizontal: getResponsiveValue({
      mobile: 10,
      tablet: 12,
      laptop: 12,
      desktop: 12
    }),
    paddingVertical: getResponsiveValue({
      mobile: 10,
      tablet: 12,
      laptop: 12,
      desktop: 12
    }),
    minHeight: 60,
    // No maxHeight to allow dynamic growth
  },
  
  // Mobile Capacity Styles
  mobileCapacityContent: {
    width: '100%',
  },
  mobileCapacityInputs: {
    width: '100%',
  },
  mobileCapacityRow: {
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: 15,
    gap: 8,
  },
  mobileCapacityInput: {
    borderWidth: 2,
    borderColor: '#4e7de0',
    borderRadius: 4,
    padding: 8,
    fontSize: 14,
    fontFamily: 'Roboto',
    textAlign: 'center',
    minWidth: 60,
    flex: 1,
    color: '#000000',
    backgroundColor: 'transparent',
    ...(Platform.OS === 'web' && {
      outlineStyle: 'none',
    }),
  },
  mobileCapacityToText: {
    color: '#000000',
    fontSize: 14,
    fontFamily: 'VastagoGrotesk',
    letterSpacing: 0.3,
  },

  // Two-column grid for mobile options
  mobileTabOptionsGrid: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    justifyContent: 'space-between',
    gap: getResponsiveValue({
      mobile: 4,
      tablet: 10,
      laptop: 10,
      desktop: 10
    }),
  },

  mobileTabOption: {
    flexDirection: 'row',
    alignItems: 'center',
    paddingHorizontal: getResponsiveValue({
      mobile: 8,
      tablet: 12,
      laptop: 12,
      desktop: 12
    }),
    paddingVertical: getResponsiveValue({
      mobile: 8,
      tablet: 10,
      laptop: 10,
      desktop: 10
    }),
    marginBottom: getResponsiveValue({
      mobile: 6,
      tablet: 8,
      laptop: 8,
      desktop: 8
    }),
    backgroundColor: 'transparent',
    borderRadius: 8,
    minHeight: getResponsiveValue({
      mobile: 40,
      tablet: 44,
      laptop: 44,
      desktop: 44
    }),
    borderWidth: 1,
    borderColor: 'transparent',
    // Two columns on mobile
    width: getResponsiveValue({
      mobile: '48%',
      tablet: '100%',
      laptop: '100%',
      desktop: '100%'
    }),
    ...(Platform.OS === 'web' && {
      cursor: 'pointer',
      transition: 'all 0.2s ease',
      ':hover': {
        backgroundColor: 'transparent',
        borderColor: 'transparent',
      },
    }),
  },
}); 